export const RADIO_BUTTON__LABEL_CLASS = 'radio_button__label';
export const RADIO_BUTTON__LABEL_TEXT_CLASS = 'radio_button__label-text';
